import React, {
  useState,
  useEffect,
  useLayoutEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import _ from "lodash";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import SignaturePad from "signature_pad";
import $ from "jquery";
import axios from "axios";

import user_service from "../../service/user_service";
import http from "../../service/http_common";
import Loader from "../../../Pages/Loader/Loader.js";
import Toaster from "../../../Pages/Toaster/Toaster.js";
import { useNavigate, useParams, NavLink, useLocation } from "react-router-dom";
import jwt from "jwt-decode";

import {
  AD_PLAN_CARDS,
  inferVendorAdTypeFromItem,
  mergeVendorProductSession,
  vendorAgreementSignatureOnFile,
  vendorProductStorageKey,
  VENDOR_ONBOARDING_STEP,
} from "./constants";
import VendorNewListingStepIndicator from "./VendorNewListingStepIndicator";
import VendorOnboardingStepInformation from "./VendorOnboardingStepInformation";
import VendorOnboardingStepPayment from "./VendorOnboardingStepPayment";
import VendorOnboardingStepSignature from "./VendorOnboardingStepSignature";
import environment from "../../../config/environment.js";
function editorStateFromHtml(html) {
  if (!html || typeof html !== "string" || !String(html).trim()) {
    return EditorState.createEmpty();
  }
  try {
    const contentBlock = htmlToDraft(html);
    if (contentBlock?.contentBlocks?.length) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks,
        contentBlock.entityMap
      );
      return EditorState.createWithContent(contentState);
    }
  } catch (e) {
    console.warn("vendor onboarding editorStateFromHtml", e);
  }
  return EditorState.createEmpty();
}

const NEW_VENDOR_AD_PATH = "/vendor-new-ad";

/**
 * Logged-in vendor flow for a second (or later) ad: listing details, payment, signature.
 * Separate from the invite-based `/vendor-onboarding/:id` flow so each route stays simple.
 */
const VendorNewListing = () => {
  const params = useParams();
  const location = useLocation();
  const [acceptedFileTypes, setAcceptedFileTypes] = useState([]);
  const navigate = useNavigate();
  const [formErrors, setFormErrors] = useState({});

  const [formErrorsVendor, setFormErrorsVendor] = useState({});
  const [isSubmitClickVendor, setISSubmitClickVendor] = useState(false);

  const [loader, setLoader] = useState({ isActive: null });
  const { isActive } = loader;
  const [toaster, setToaster] = useState({
    type: null,
    isShow: null,
    toasterBody: "",
    message: "",
  });
  const { type, isShow, toasterBody, message } = toaster;
  const [category, setCategory] = useState("");
  const [stepPayment, setStepPayment] = useState(false);
  const [stepSignature, setStepSignature] = useState(false);
  const [agreementAccepted, setAgreementAccepted] = useState(false);
  const [vendorPaymentComplete, setVendorPaymentComplete] = useState(false);
  const paymentReturnHandled = useRef(false);
  const listingHydratedRef = useRef(false);
  const newListingFlowInitRef = useRef(false);
  const resumeHandledRef = useRef(false);

  const initialValues = {
    firstName: "",
    nickName: "",
    middleName: "",
    middleInitials: "",
    prefix: "",
    lastName: "",
    maidenName: "",
    suffix: "",
    email: "",
    passwordHash: "",
    confirmPassword: "",
  };

  const [accountData, setAccountData] = useState(initialValues);

  const agreementOnFile = useMemo(
    () => vendorAgreementSignatureOnFile(accountData),
    [accountData?.onboard_signature]
  );

  const initialValuesVendor = {
    office: "",
    productname: "",
    productblurb: "",
    description: "",
    linkurl: "",
    email: "",
    contactName: "",
    phone: "",
    product_fullDetails: "",
    companyName: "",
    adType: "",
  };

  const initialImage = {
    image: [],
  };
  const [formValues, setFormValues] = useState(initialValuesVendor);
  const [imageData, setImageData] = useState(initialImage);

  /**
   * Clear only when opening “Create new ad” from vendor home (?draft=new); keep session for payment return and refreshes.
   */
  useLayoutEffect(() => {
    const id = params.id;
    if (typeof window !== "undefined" && id) {
      const sp = new URLSearchParams(window.location.search);
      if (sp.get("draft") === "new") {
        newListingFlowInitRef.current = false;
        sessionStorage.removeItem(vendorProductStorageKey(id));
        navigate(`${NEW_VENDOR_AD_PATH}/${id}`, { replace: true });
      }
    }

    const token = localStorage.getItem("auth");
    if (!token) return;
    try {
      const p = jwt(token);
      const sameVendor =
        String(p.id) === String(params.id) &&
        String(p.contactType || "").toLowerCase() === "vendor";
      if (sameVendor) return;
    } catch {
      /* fall through to clear */
    }
    localStorage.removeItem("auth");
    localStorage.removeItem("active_office");
    localStorage.removeItem("active_office_id");
  }, [params.id, navigate]);

  useEffect(() => {
    window.scrollTo(0, 0);
    ContactGetByuniqueid();
  }, [params.id]);

  useEffect(() => {
    const id = params.id;
    if (!id) return;
    const search = new URLSearchParams(window.location.search);
    const vp = search.get("vendor_payment");
    const sid = search.get("session_id");
    if (vp === "0") {
      if (paymentReturnHandled.current) return;
      paymentReturnHandled.current = true;
      navigate(`${NEW_VENDOR_AD_PATH}/${id}`, { replace: true });
      setToaster({
        type: "info",
        isShow: true,
        message: "Payment was cancelled. You can try again when you’re ready.",
      });
      setTimeout(() => setToaster((p) => ({ ...p, isShow: false })), 4000);
      return;
    }
    if (vp !== "1" || !sid) return;
    if (paymentReturnHandled.current) return;
    paymentReturnHandled.current = true;
    let cancelled = false;
    (async () => {
      try {
        setLoader({ isActive: true });
        const confirmRes = await user_service.vendorAdsPaymentConfirm(sid);
        if (cancelled) return;
        const key = vendorProductStorageKey(id);
        const item = confirmRes?.data?.item;
        const idFromServer = item?._id ? String(item._id) : null;
        const raw = sessionStorage.getItem(key);
        let productItemId = null;
        if (raw) {
          try {
            const parsed = JSON.parse(raw);
            productItemId = parsed.productItemId;
          } catch {
            productItemId = null;
          }
        }
        if (!productItemId && idFromServer) {
          productItemId = idFromServer;
        }
        if (productItemId) {
          sessionStorage.setItem(
            key,
            JSON.stringify({ productItemId, paid: true })
          );
        }
        const confirmedAdType = inferVendorAdTypeFromItem(item);
        if (confirmedAdType) {
          setFormValues((prev) => ({ ...prev, adType: confirmedAdType }));
        }
        setVendorPaymentComplete(true);
        navigate(`${NEW_VENDOR_AD_PATH}/${id}`, { replace: true });
        setCategory(false);
        let signed = vendorAgreementSignatureOnFile(accountData);
        if (!signed) {
          try {
            const cr = await user_service.contactGetById(id);
            signed = vendorAgreementSignatureOnFile(cr?.data);
          } catch {
            signed = false;
          }
        }
        if (signed) {
          setStepPayment(true);
          setStepSignature(false);
        } else {
          setStepPayment(false);
          setStepSignature(true);
        }
        setLoader({ isActive: false });
        setToaster({
          type: "success",
          isShow: true,
          message: signed
            ? "Payment received. Your saved vendor agreement applies — click Finish to return to your ads."
            : "Payment received. Please complete the agreement and signature below.",
        });
        setTimeout(() => setToaster((p) => ({ ...p, isShow: false })), 5000);
      } catch (err) {
        if (cancelled) return;
        setLoader({ isActive: false });
        paymentReturnHandled.current = false;
        navigate(`${NEW_VENDOR_AD_PATH}/${id}`, { replace: true });
        setToaster({
          type: "error",
          isShow: true,
          message:
            err.response?.data?.message ||
            err.message ||
            "Could not confirm payment.",
        });
        setTimeout(() => setToaster((p) => ({ ...p, isShow: false })), 5000);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [params.id, navigate]);

  useEffect(() => {
    listingHydratedRef.current = false;
  }, [params.id]);

  useEffect(() => {
    const sp = new URLSearchParams(location.search);
    if (!sp.get("resume")) resumeHandledRef.current = false;
  }, [location.search, params.id]);

  /**
   * Payment is stored on ProductItems.vendorAdPaymentStatus (backend). sessionStorage is empty
   * when the user opens the email link in another browser — hydrate from API after contact loads.
   */
  useEffect(() => {
    const id = params.id;
    if (!id) return;
    if (accountData?.onboardfinal === "done") return;
    if (!accountData?.passwordHash) return;

    let cancelled = false;
    (async () => {
      try {
        const res = await user_service.vendorAdsOnboardingPaymentState(id);
        if (cancelled) return;
        const data = res?.data;
        if (!data?.found || !data.paid || !data.productItemId) return;

        setVendorPaymentComplete(true);
        const stateAdType = inferVendorAdTypeFromItem(data);
        if (stateAdType) {
          setFormValues((prev) => ({ ...prev, adType: stateAdType }));
        }
        sessionStorage.setItem(
          vendorProductStorageKey(id),
          JSON.stringify({ productItemId: data.productItemId, paid: true })
        );
        setCategory(false);
        setStepPayment(false);
        setStepSignature(true);
      } catch (e) {
        console.error("vendor onboarding payment state:", e);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [params.id, accountData?.onboardfinal, accountData?.passwordHash]);

  /**
   * Paid listing may have adType only on the server; sync into form so plan cards show selected and validation matches.
   */
  useEffect(() => {
    const id = params.id;
    if (!id || !vendorPaymentComplete || formValues.adType) return;
    const raw = sessionStorage.getItem(vendorProductStorageKey(id));
    if (!raw) return;
    let productItemId;
    try {
      productItemId = JSON.parse(raw).productItemId;
    } catch {
      return;
    }
    if (!productItemId) return;
    let cancelled = false;
    (async () => {
      try {
        const pr = await user_service.productItemsGetId(productItemId);
        if (cancelled) return;
        const item = pr?.data;
        const at = inferVendorAdTypeFromItem(item);
        if (at) {
          setFormValues((prev) => ({ ...prev, adType: at }));
          setFormErrorsVendor((prev) => ({ ...prev, adType: undefined }));
        }
      } catch (e) {
        console.error("vendor onboarding adType backfill:", e);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [params.id, vendorPaymentComplete, formValues.adType]);

  /**
   * Restore wizard step from session (vendor has already completed first-time onboarding).
   * If payment is done and the contact already has a vendor agreement signature, skip the signature step.
   */
  const applySessionSteps = useCallback(
    (contactData) => {
      const id = params.id;
      if (!id) return;

      if (contactData.onboardfinal !== "done") {
        navigate(`/vendor-onboarding/${id}`, { replace: true });
        return;
      }

      const signed = vendorAgreementSignatureOnFile(contactData);

      let parsed = null;
      try {
        const raw = sessionStorage.getItem(vendorProductStorageKey(id));
        if (raw) parsed = JSON.parse(raw);
      } catch {
        parsed = null;
      }
      const paid = parsed?.paid === true;
      const productItemId = parsed?.productItemId;
      const step = parsed?.onboardingStep;

      if (paid && productItemId) {
        setVendorPaymentComplete(true);
        setCategory(false);
        if (signed) {
          setStepPayment(true);
          setStepSignature(false);
        } else {
          setStepPayment(false);
          setStepSignature(true);
        }
        return;
      }

      if (productItemId && !paid) {
        if (step === VENDOR_ONBOARDING_STEP.INFO) {
          setCategory(true);
          setStepPayment(false);
          setStepSignature(false);
          setVendorPaymentComplete(false);
          return;
        }
        setCategory(false);
        setStepPayment(true);
        setStepSignature(false);
        setVendorPaymentComplete(false);
        return;
      }

      setCategory(true);
      setStepPayment(false);
      setStepSignature(false);
      setVendorPaymentComplete(false);
    },
    [params.id, navigate]
  );

  /**
   * Deep link from My vendor ads: ?resume=<productItemId> restores draft and opens the right step.
   */
  useEffect(() => {
    const id = params.id;
    if (!id) return;
    if (!accountData?.passwordHash) return;
    if (accountData.onboardfinal !== "done") return;
    const sp = new URLSearchParams(location.search);
    const resumeId = sp.get("resume");
    if (!resumeId || resumeHandledRef.current) return;

    let cancelled = false;
    (async () => {
      try {
        const pr = await user_service.productItemsGetId(resumeId);
        if (cancelled) return;
        const item = pr?.data;
        if (!item) return;
        const owner = String(item.vendorContactId ?? item.agentId ?? "");
        if (owner !== String(id)) return;
        resumeHandledRef.current = true;
        const paid =
          String(item.vendorAdPaymentStatus || "").toLowerCase() === "paid";
        mergeVendorProductSession(id, {
          productItemId: resumeId,
          paid,
          onboardingStep: paid
            ? VENDOR_ONBOARDING_STEP.PAYMENT
            : VENDOR_ONBOARDING_STEP.INFO,
        });
        listingHydratedRef.current = false;
        navigate(`${NEW_VENDOR_AD_PATH}/${id}`, { replace: true });
        applySessionSteps(accountData);
      } catch {
        resumeHandledRef.current = false;
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [
    params.id,
    location.search,
    accountData?.passwordHash,
    accountData?.onboardfinal,
    accountData?.onboard_signature,
    navigate,
    applySessionSteps,
  ]);

  const ContactGetByuniqueid = async () => {
    await user_service.contactGetById(params.id).then((response) => {
      if (response && response.data) {
        const data = response.data || {};
        setAccountData(data);
        if (!data.passwordHash) {
          navigate(`/vendor-onboarding/${params.id}`, { replace: true });
          return;
        }
        if (data.onboardfinal !== "done") {
          navigate(`/vendor-onboarding/${params.id}`, { replace: true });
          return;
        }
        applySessionSteps(data);
      }
    });
  };

  const [products, setProducts] = useState([]);

  const PromotoProductsGet = async (officeName) => {
    if (!officeName) {
      setLoader({ isActive: false });
      return;
    }
    try {
      const response = await user_service.PromotoProductsGet(officeName);

      if (response) {
        const vendorData = response.data.data.filter(
          (item) => String(item.category || "").toLowerCase() === "vendor"
        );
        setProducts(vendorData);
      }

      setLoader({ isActive: false });
    } catch (error) {
      console.error("Error fetching vendor data:", error);
      setLoader({ isActive: false });
    }
  };

  useEffect(() => {
    const office = accountData?.active_office;
    if (!office) return;
    setLoader({ isActive: true });
    PromotoProductsGet(office);
  }, [accountData?.active_office]);

  const [selectedVendor, setSelectedVendor] = useState({
    _id: "",
    description: "",
  });

  useEffect(() => {
    newListingFlowInitRef.current = false;
  }, [params.id]);

  /**
   * Fresh form for a new ad after contact loads. Skip when returning from Stripe so session/step state wins.
   */
  useEffect(() => {
    if (!params.id) return;
    if (!accountData?.passwordHash) return;
    if (accountData.onboardfinal !== "done") return;
    if (newListingFlowInitRef.current) return;
    const sp = new URLSearchParams(window.location.search);
    const vp = sp.get("vendor_payment");
    if (vp === "1" || vp === "0") return;
    if (sp.get("resume")) return;
    let existingSession = null;
    try {
      const raw = sessionStorage.getItem(vendorProductStorageKey(params.id));
      if (raw) existingSession = JSON.parse(raw);
    } catch {
      existingSession = null;
    }
    if (existingSession?.productItemId) {
      newListingFlowInitRef.current = true;
      return;
    }
    newListingFlowInitRef.current = true;

    setVendorPaymentComplete(false);
    setAgreementAccepted(false);
    setFormValues({ ...initialValuesVendor });
    setImageData({ image: [] });
    setEditorState(EditorState.createEmpty());
    setFormErrorsVendor({});
    setISSubmitClickVendor(false);
    setCategory(true);
    setStepPayment(false);
    setStepSignature(false);
    listingHydratedRef.current = false;
    setSelectedVendor({ _id: "", description: "" });
  }, [params.id, accountData?.passwordHash, accountData?.onboardfinal]);

  /**
   * Reload listing fields from the server for an in-progress draft (contact already fully onboarded).
   */
  useEffect(() => {
    const id = params.id;
    if (!id || !accountData?.passwordHash) return;
    if (accountData.onboardfinal !== "done") return;
    if (listingHydratedRef.current) return;

    let parsed = null;
    try {
      const raw = sessionStorage.getItem(vendorProductStorageKey(id));
      if (raw) parsed = JSON.parse(raw);
    } catch {
      return;
    }
    if (!parsed?.productItemId) return;
    if (products.length === 0) return;

    let cancelled = false;
    (async () => {
      try {
        const pr = await user_service.productItemsGetId(parsed.productItemId);
        if (cancelled) return;
        const item = pr?.data;
        if (!item) return;

        setFormValues((prev) => ({
          ...prev,
          productname: item.productname || "",
          productblurb: item.productblurb || "",
          description: item.description || "",
          linkurl: item.linkurl || "",
          email: item.email || "",
          contactName: item.contactName || "",
          phone: item.phone || "",
          companyName: item.companyName || "",
          product_fullDetails: item.product_fullDetails || "",
          adType:
            inferVendorAdTypeFromItem(item) || prev.adType || "",
        }));

        if (item.image && Array.isArray(item.image)) {
          setImageData({ image: item.image });
        }

        const catId = item.category_id;
        if (catId) {
          const match = products.find(
            (p) => String(p._id) === String(catId)
          );
          if (match) setSelectedVendor(match);
        }

        setEditorState(editorStateFromHtml(item.product_fullDetails || ""));
        listingHydratedRef.current = true;
      } catch (e) {
        console.error("vendor listing hydrate:", e);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [params.id, accountData?.passwordHash, accountData?.onboardfinal, products]);

  const handleSelectChange = (e) => {
    const selectedVendorId = e.target.value;
    const vendor = products.find((vendor) => vendor._id === selectedVendorId);

    setSelectedVendor(vendor || {});
  };

  const handleChangevendor = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });

    $("input[name='phone']").keyup(function () {
      $(this).val(
        $(this)
          .val()
          .replace(/^(\d{3})(\d{3})(\d+)$/, "$1-$2-$3")
      );
      const formattedNumber = value.replace(
        /^(\d{3})(\d{3})(\d+)$/,
        "$1-$2-$3"
      );
      setFormValues({ ...formValues, ["phone"]: formattedNumber });
    });
  };

  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      const formData = new FormData();
      formData.append("file", selectedFile);

      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("auth")}`,
        },
      };

      try {
        const uploadResponse = await axios.post(
          environment.uploadUrl,
          formData,
          config
        );

        const uploadedFileURL = uploadResponse.data;
        setImageData((prevImageData) => ({
          ...prevImageData,
          image: [
            ...(prevImageData.image || []),
            {
              images: uploadedFileURL,
            },
          ],
        }));
      } catch (error) {
        console.error("Error occurred during file upload:", error);
      }
    }
  };

  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const handleChangesVendor = (editorState) => {
    setEditorState(editorState);
    const htmlContent = draftToHtml(
      convertToRaw(editorState.getCurrentContent())
    );
    setFormValues({ ...formValues, product_fullDetails: htmlContent });
  };

  useEffect(() => {
    if (formValues && isSubmitClickVendor) {
      validateVendorInfo();
    }
  }, [formValues]);

  const validateVendorInfo = () => {
    const values = formValues;
    const errors = {};

    if (!String(values.companyName || "").trim()) {
      errors.companyName = "Company name is required.";
    }

    if (!selectedVendor.description) {
      errors.category = "Product category is required.";
    }

    if (!values.productname || !String(values.productname).trim()) {
      errors.productname = "Product name is required.";
    } else if (values.productname.length > 100) {
      errors.productname = "Product name must be 100 characters or less.";
    }

    if (!String(values.contactName || "").trim()) {
      errors.contactName = "Owner / contact name is required.";
    }

    const emailTrim = String(values.email || "").trim();
    if (!emailTrim) {
      errors.email = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailTrim)) {
      errors.email = "Enter a valid email address.";
    }

    const phoneDigits = String(values.phone || "").replace(/\D/g, "");
    if (!phoneDigits || phoneDigits.length < 10) {
      errors.phone = "Phone is required (at least 10 digits).";
    }

    if (values.productblurb && values.productblurb.length > 50) {
      errors.productblurb = "Product blurb must be 50 characters or less.";
    }
    if (values.description && values.description.length > 500) {
      errors.description = "Description must be 500 characters or less.";
    }

    const urlTrim = String(values.linkurl || "").trim();
    if (!urlTrim) {
      errors.linkurl = "Website URL is required.";
    } else if (!/^https?:\/\/\S+$/i.test(urlTrim)) {
      errors.linkurl = "Website URL must start with http:// or https://";
    }

    const imgs = imageData?.image;
    const hasImage =
      Array.isArray(imgs) &&
      imgs.some((x) => {
        const url = x?.images ?? x?.url ?? x;
        return typeof url === "string" && url.trim().length > 0;
      });
    if (!hasImage) {
      errors.image = "At least one image is required.";
    }

    setFormErrorsVendor(errors);
    return errors;
  };

  const validateVendorFull = () => {
    const errors = { ...validateVendorInfo() };
    if (!formValues.adType && !vendorPaymentComplete) {
      errors.adType = "Please select an advertising plan on the Payment step.";
    }
    setFormErrorsVendor(errors);
    return errors;
  };

  const handleSelectAdPlan = (value) => {
    if (vendorPaymentComplete) return;
    setFormValues((prev) => ({ ...prev, adType: value }));
    setFormErrorsVendor((prev) => ({ ...prev, adType: undefined }));

    const plan = AD_PLAN_CARDS.find((p) => p.value === value);
    const contactId = params.id;
    if (!contactId || !plan) return;
    let productItemId = null;
    try {
      const raw = sessionStorage.getItem(vendorProductStorageKey(contactId));
      if (raw) productItemId = JSON.parse(raw).productItemId;
    } catch {
      return;
    }
    if (!productItemId) return;
    user_service
      .productItemsUpdate(productItemId, {
        adType: value,
        vendorAdPackageMonths: plan.months,
      })
      .catch((err) => console.error("Persist vendor ad plan:", err));
  };

  /** Shared listing fields for create and update (does not reset payment / vendor ad workflow fields). */
  const buildVendorListingCorePayload = () => {
    const plan = AD_PLAN_CARDS.find((p) => p.value === formValues.adType);
    const pkgMonths = plan?.months ?? 6;
    return {
      agentId: params.id,
      sponsorAgentId: accountData.agentId
        ? String(accountData.agentId)
        : undefined,
      vendorContactId: params.id,
      office_id: accountData.active_office_id,
      office_name: accountData.active_office,
      category: selectedVendor.description,
      category_id: selectedVendor._id,
      productname: formValues.productname,
      productblurb: formValues.productblurb,
      description: formValues.description,
      linkurl: formValues.linkurl,
      email: String(formValues.email || "").trim(),
      contactName: formValues.contactName,
      phone: formValues.phone,
      companyName: formValues.companyName,
      product_fullDetails: formValues.product_fullDetails,
      image: imageData.image,
      adType: formValues.adType || "",
      vendorAdPackageMonths: pkgMonths,
    };
  };

  const buildVendorProductCreatePayload = () => ({
    ...buildVendorListingCorePayload(),
    is_active: "0",
    vendorAdStatus: "pending",
    vendorAdPaymentStatus: "pending",
    vendorAdApprovalRequestedAt: new Date().toISOString(),
  });

  /** PUT: only listing fields — preserves payment and Stripe fields on the server. */
  const buildVendorProductUpdatePayload = () => buildVendorListingCorePayload();

  const handleSaveAndContinueFromInfo = async (e) => {
    e.preventDefault();
    setISSubmitClickVendor(true);
    const checkValue = validateVendorInfo();
    if (!_.isEmpty(checkValue)) {
      return;
    }

    const id = params.id;
    const storageKey = vendorProductStorageKey(id);
    setLoader({ isActive: true });

    try {
      let savedId = null;
      try {
        const raw = sessionStorage.getItem(storageKey);
        if (raw) {
          const parsed = JSON.parse(raw);
          if (parsed.productItemId && !parsed.paid) {
            savedId = parsed.productItemId;
          }
        }
      } catch {
        sessionStorage.removeItem(storageKey);
      }

      if (savedId) {
        try {
          await user_service.productItemsUpdate(
            savedId,
            buildVendorProductUpdatePayload()
          );
        } catch (err) {
          if (err?.response?.status === 404) {
            savedId = null;
          } else {
            throw err;
          }
        }
      }

      if (!savedId) {
        const response = await user_service.addProductItems(
          buildVendorProductCreatePayload()
        );
        const productItemId =
          response?.data?._id ||
          response?.data?.data?._id ||
          response?.data?.id;
        if (!productItemId) {
          throw new Error("Could not save your listing. Please try again.");
        }
        savedId = String(productItemId);
      }

      mergeVendorProductSession(id, {
        productItemId: String(savedId),
        paid: false,
        onboardingStep: VENDOR_ONBOARDING_STEP.PAYMENT,
      });

      setCategory(false);
      setStepPayment(true);
      setLoader({ isActive: false });
      setToaster({
        type: "success",
        isShow: true,
        message: "Your listing details were saved.",
      });
      setTimeout(() => setToaster((p) => ({ ...p, isShow: false })), 3000);
    } catch (error) {
      console.error("Save vendor listing (step 2):", error);
      setLoader({ isActive: false });
      setToaster({
        type: "error",
        isShow: true,
        message:
          error.response?.data?.message ||
          error.message ||
          "Could not save your listing.",
      });
      setTimeout(() => setToaster((p) => ({ ...p, isShow: false })), 4000);
    }
  };

  const handleFinishNewListingWithExistingAgreement = () => {
    const id = params.id;
    const storageKey = vendorProductStorageKey(id);
    let parsed = null;
    try {
      const raw = sessionStorage.getItem(storageKey);
      parsed = raw ? JSON.parse(raw) : null;
    } catch {
      parsed = null;
    }
    if (!parsed?.productItemId || !parsed?.paid) {
      setToaster({
        type: "error",
        isShow: true,
        message:
          "Payment must be completed first. Use Pay with card, then finish here.",
      });
      setTimeout(() => setToaster((p) => ({ ...p, isShow: false })), 4000);
      return;
    }
    sessionStorage.removeItem(storageKey);
    navigate("/my-vendor-ads");
    setToaster({
      type: "success",
      isShow: true,
      message:
        "Your ad is submitted for admin review. Your existing agreement signature still applies.",
    });
    setTimeout(() => setToaster((p) => ({ ...p, isShow: false })), 4000);
  };

  const handleContinueFromPayment = (e) => {
    e.preventDefault();
    if (!vendorPaymentComplete) {
      if (!formValues.adType) {
        setFormErrorsVendor((prev) => ({
          ...prev,
          adType: "Please select one of the advertising plans.",
        }));
        setToaster({
          type: "error",
          isShow: true,
          message: "Please select an advertising plan.",
        });
        setTimeout(() => {
          setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
        }, 3000);
        return;
      }
      setToaster({
        type: "info",
        isShow: true,
        message:
          "Please complete payment with card first. Use “Pay with card” below.",
      });
      setTimeout(() => {
        setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
      }, 4000);
      return;
    }
    setFormErrorsVendor((prev) => ({ ...prev, adType: undefined }));
    if (agreementOnFile) {
      handleFinishNewListingWithExistingAgreement();
      return;
    }
    setStepPayment(false);
    setStepSignature(true);
  };

  const handlePayWithCard = async (e) => {
    e.preventDefault();
    setISSubmitClickVendor(true);
    const checkValue = validateVendorFull();
    if (!_.isEmpty(checkValue)) {
      setToaster({
        type: "error",
        isShow: true,
        message:
          "Please complete all required fields on the Information step before paying.",
      });
      setTimeout(() => {
        setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
      }, 4000);
      return;
    }
    const id = params.id;
    const storageKey = vendorProductStorageKey(id);
    setLoader({ isActive: true });
    try {
      let productItemId = null;
      try {
        const existing = sessionStorage.getItem(storageKey);
        if (existing) {
          const parsed = JSON.parse(existing);
          if (parsed.productItemId && !parsed.paid) {
            try {
              const pr = await user_service.productItemsGetId(
                parsed.productItemId
              );
              const item = pr?.data;
              const status = String(
                item?.vendorAdPaymentStatus || ""
              ).toLowerCase();
              if (item && status !== "paid") {
                productItemId = parsed.productItemId;
              }
            } catch {
              /* orphan id — create a new listing below */
            }
          }
        }
      } catch {
        sessionStorage.removeItem(storageKey);
      }
      if (!productItemId) {
        const userData = buildVendorProductCreatePayload();
        const response = await user_service.addProductItems(userData);
        productItemId =
          response?.data?._id ||
          response?.data?.data?._id ||
          response?.data?.id;
        if (!productItemId) {
          throw new Error("Could not create your listing. Please try again.");
        }
        mergeVendorProductSession(id, {
          productItemId,
          paid: false,
          onboardingStep: VENDOR_ONBOARDING_STEP.PAYMENT,
        });
      }
      const origin = window.location.origin;
      const successUrl = `${origin}${NEW_VENDOR_AD_PATH}/${id}?vendor_payment=1&session_id={CHECKOUT_SESSION_ID}`;
      const cancelUrl = `${origin}${NEW_VENDOR_AD_PATH}/${id}?vendor_payment=0`;
      const planCard = AD_PLAN_CARDS.find((p) => p.value === formValues.adType);
      const payResp = await user_service.vendorAdsPaymentCreateSession(
        productItemId,
        successUrl,
        cancelUrl,
        {
          adType: formValues.adType,
          vendorAdPackageMonths: planCard?.months ?? 6,
        }
      );
      const payUrl = payResp?.data?.url;
      if (!payUrl) {
        throw new Error(
          payResp?.data?.message ||
            "Payment session could not be started. Try again or contact support."
        );
      }
      window.location.href = payUrl;
    } catch (error) {
      console.error("Vendor Stripe checkout:", error);
      setLoader({ isActive: false });
      setToaster({
        type: "error",
        isShow: true,
        message:
          error.response?.data?.message ||
          error.message ||
          "Could not start payment.",
      });
      setTimeout(() => {
        setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
      }, 4000);
    }
  };

  const [signaturePad, setSignaturePad] = useState(null);
  let signatureRedoArray = [];

  const readyPad = () => {
    const wrapper = document.getElementById("signature-pad");
    if (!wrapper) {
      console.error("Signature pad wrapper not found!");
      return;
    }

    const canvas = wrapper.querySelector("canvas");
    if (!canvas) {
      console.error("Canvas element not found!");
      return;
    }

    const context = canvas.getContext("2d");
    if (!context) {
      console.error("Could not get the 2D context for canvas!");
      return;
    }

    const w = Math.max(wrapper.clientWidth || 600, 280);
    const h = 200;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    canvas.width = w * ratio;
    canvas.height = h * ratio;
    canvas.style.width = `${w}px`;
    canvas.style.height = `${h}px`;
    context.scale(ratio, ratio);

    const tempSignaturePad = new SignaturePad(canvas, {
      backgroundColor: "rgb(255, 255, 255)",
    });

    setSignaturePad(tempSignaturePad);
  };

  function dataURLToBlob(dataURL) {
    const parts = dataURL.split(";base64,");
    const contentType = parts[0].split(":")[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);

    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }

    return new Blob([uInt8Array], { type: contentType });
  }

  const handleUndo = () => {
    if (!signaturePad) return;
    let signatureRemovedData = [];
    let signatureData = signaturePad.toData();
    let signatureRedoData = _.cloneDeep(signatureData);

    if (signatureData.length > 0) {
      signatureData.pop();
      signaturePad.fromData(signatureData);
      signatureRemovedData = signatureRedoData[signatureRedoData.length - 1];
      signatureRedoArray.push(signatureRemovedData);
    }
  };

  const handleClear = () => {
    if (signaturePad) signaturePad.clear();
  };

  useEffect(() => {
    if (!stepSignature) return undefined;
    window.scrollTo(0, 0);
    const id = setTimeout(() => readyPad(), 150);
    return () => clearTimeout(id);
  }, [stepSignature]);

  const handleCompleteOnboarding = async (e) => {
    e.preventDefault();
    setISSubmitClickVendor(true);
    const checkValue = validateVendorFull();
    if (!_.isEmpty(checkValue)) {
      setToaster({
        type: "error",
        isShow: true,
        message:
          "Please complete all required fields (steps 2–3) or go back to fix them.",
      });
      setTimeout(() => {
        setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
      }, 3000);
      return;
    }
    if (!agreementAccepted) {
      setToaster({
        type: "error",
        isShow: true,
        message:
          "Please review and accept the Vendor Advertising Agreement before continuing.",
      });
      setTimeout(() => {
        setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
      }, 3000);
      return;
    }
    if (!signaturePad || signaturePad.isEmpty()) {
      setToaster({
        type: "error",
        isShow: true,
        message: "Please sign in the box below to confirm your agreement.",
      });
      setTimeout(() => {
        setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
      }, 3000);
      return;
    }
    const dataURL = signaturePad.toDataURL();
    const signatureBlob = dataURLToBlob(dataURL);
    const formData = new FormData();
    formData.append("file", signatureBlob, "vendor-signature.png");
    try {
      setLoader({ isActive: true });
      const base = String(http.defaults.baseURL || "").replace(/\/$/, "");
      const uploadRes = await fetch(`${base}/upload`, {
        method: "POST",
        body: formData,
      });
      if (!uploadRes.ok) {
        let errMsg = uploadRes.statusText;
        try {
          const errBody = await uploadRes.json();
          errMsg = errBody.message || errMsg;
        } catch {
          errMsg = (await uploadRes.text()) || errMsg;
        }
        throw new Error(errMsg);
      }
      const uploadedUrl = await uploadRes.text();
      const storageKey = vendorProductStorageKey(params.id);
      let parsed = null;
      try {
        const raw = sessionStorage.getItem(storageKey);
        parsed = raw ? JSON.parse(raw) : null;
      } catch {
        parsed = null;
      }
      const productItemId = parsed?.productItemId;
      const isPaid = parsed?.paid === true;
      if (!productItemId || !isPaid) {
        throw new Error(
          "Payment is required before you can finish. Use the Payment step to complete checkout, then return here."
        );
      }

      await user_service.contactUpdate(params.id, {
        onboardfinal: "done",
        onboard_signature: uploadedUrl,
      });
      sessionStorage.removeItem(storageKey);
      setVendorPaymentComplete(false);
      setLoader({ isActive: false });

      setToaster({
        type: "success",
        isShow: true,
        message:
          "Your new ad was submitted and is pending admin approval.",
      });
      setTimeout(() => {
        setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
      }, 4000);
      navigate("/my-vendor-ads");
    } catch (error) {
      console.error("Error occurred while completing vendor onboarding:", error);
      setLoader({ isActive: false });
      setToaster({
        type: "error",
        isShow: true,
        message:
          error.response?.data?.message ||
          error.message ||
          "Could not save vendor profile.",
      });
      setTimeout(() => {
        setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
      }, 3000);
    }
  };

  const handleBackToVendorHome = () => navigate("/my-vendor-ads");

  return (
    <div className="bg-secondary float-left w-100 pt-4 mb-4">
      <Loader isActive={isActive} />
      {isShow && (
        <Toaster
          type={type}
          isShow={isShow}
          toasterBody={toasterBody}
          message={message}
        />
      )}
      <div className="container onboarding">
        <main className="page-wrapper homepage_layout getContact_page_wrap">
          <div className="onboardingbutton">
            <div className="">
              <>
                  <h3 className="">Create a new vendor ad</h3>
                  <div className="mb-3">
                    <NavLink
                      to="/my-vendor-ads"
                      className="btn btn-outline-light btn-sm"
                    >
                      ← My vendor ads
                    </NavLink>
                  </div>
                  <p>
                    Add details for your new listing. You can return to your
                    vendor ads dashboard at any time using the link above.
                  </p>
                  <VendorNewListingStepIndicator
                    category={category}
                    stepPayment={stepPayment}
                    stepSignature={stepSignature}
                    hideSignatureStep={agreementOnFile}
                  />

                  {category ? (
                    <VendorOnboardingStepInformation
                      formValues={formValues}
                      formErrorsVendor={formErrorsVendor}
                      formErrors={formErrors}
                      selectedVendor={selectedVendor}
                      products={products}
                      imageData={imageData}
                      acceptedFileTypes={acceptedFileTypes}
                      editorState={editorState}
                      handleChangevendor={handleChangevendor}
                      handleSelectChange={handleSelectChange}
                      handleFileChange={handleFileChange}
                      handleChangesVendor={handleChangesVendor}
                      onBack={handleBackToVendorHome}
                      onContinue={handleSaveAndContinueFromInfo}
                    />
                  ) : (
                    ""
                  )}

                  {stepPayment ? (
                    <VendorOnboardingStepPayment
                      formValues={formValues}
                      formErrorsVendor={formErrorsVendor}
                      vendorPaymentComplete={vendorPaymentComplete}
                      agreementOnFile={agreementOnFile}
                      handleSelectAdPlan={handleSelectAdPlan}
                      handlePayWithCard={handlePayWithCard}
                      handleContinueFromPayment={handleContinueFromPayment}
                      onBack={() => {
                        mergeVendorProductSession(params.id, {
                          onboardingStep: VENDOR_ONBOARDING_STEP.INFO,
                        });
                        setStepPayment(false);
                        setCategory(true);
                      }}
                    />
                  ) : (
                    ""
                  )}

                  {stepSignature ? (
                    <VendorOnboardingStepSignature
                      agreementAccepted={agreementAccepted}
                      setAgreementAccepted={setAgreementAccepted}
                      handleUndo={handleUndo}
                      handleClear={handleClear}
                      handleCompleteOnboarding={handleCompleteOnboarding}
                      onBack={() => {
                        mergeVendorProductSession(params.id, {
                          onboardingStep: VENDOR_ONBOARDING_STEP.PAYMENT,
                        });
                        setStepSignature(false);
                        setStepPayment(true);
                      }}
                    />
                  ) : (
                    ""
                  )}
                </>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default VendorNewListing;
